import { CustomTimer } from '@tunein/web-utils';
import { getExperiment } from '../../singletons';
import { MIDROLL_BREAKS_PER_SESSION, MIDROLL_INTERVAL_SECONDS, } from './constants';
export class MidrollScheduler {
    #requestMidroll;
    #timer;
    #remainingBreaks;
    constructor(midrollSchedulerConfig) {
        const { requestMidroll } = midrollSchedulerConfig;
        this.#requestMidroll = requestMidroll;
        const intervalSeconds = getExperiment(MIDROLL_INTERVAL_SECONDS);
        const breaksPerSession = getExperiment(MIDROLL_BREAKS_PER_SESSION);
        this.#remainingBreaks = breaksPerSession ?? Number.POSITIVE_INFINITY;
        this.#timer = new CustomTimer(this.#timerCallback, (intervalSeconds || 30 * 60) * 1000);
    }
    #timerCallback = async () => {
        if (!this.#remainingBreaks) {
            this.clear();
            return;
        }
        this.#remainingBreaks--;
        this.#requestMidroll();
    };
    start() {
        if (this.#remainingBreaks || this.#timer?.isPaused) {
            this.#timer?.start();
        }
    }
    pause() {
        this.#timer?.pause();
    }
    clear() {
        this.#timer?.clear();
    }
}
